import { z } from "zod"

export const transportationReportResponseRestSchema = z.object({
    report_id: z.string(),
})

export type TransportationReportResponseRest = z.infer<typeof transportationReportResponseRestSchema>

const baseShipmentSchema = z.object({
    shipment_number: z.string().min(1),
    ship_from: z.object({
        duns: z.string(),
        supplier_code: z.string(),
    }),
    volume: z.object({
        unit: z.enum([
            "CUBIC_DECIMETER",
            "LITER",
            "CUBIC_METER",
        ]),
        value: z.number().min(0)
    }).optional()
})

const shipmentMaterialsSchema = baseShipmentSchema.extend({
    type: z.literal("MATERIALS"),
    ship_to: z.object({
        duns: z.string(),
        plant_code: z.string().min(1)
    }),
})

export type ShipmentMaterialsRest = z.infer<typeof shipmentMaterialsSchema>

const shipmentEmptiesSchema = baseShipmentSchema.extend({
    type: z.literal("EMPTIES"),
    ship_to: z.object({
        duns: z.string(),
        supplier_code: z.string().min(1)
    }),
})

export type ShipmentEmptiesRest = z.infer<typeof shipmentEmptiesSchema>

export const transportationReportRequestRestSchema = z.object({
    transport_details: z.object({
        freight_forwarder: z.object({
            duns: z.string(),
            supplier_code: z.string(),
        }),
        transport_mode: z.object({
            type: z.literal("ROAD"),
            means_of_transport: z.enum([
                "EUROTRAILER",
                "MEGATRAILER",
                "JUMBO_SWAP_BODY",
                "JUMBO_TRAILER_PULL",
                "TRUCK_7_5_TON",
                "VAN_OR_BUS",
                "CAR",
                "GIGALINER",
                "TAUTLINER",
                "GOOSENECK_CHASSIS"
            ]),
            license_plate: z.string(),
            fuel_type: z.enum([
                "DIESEL",
                "DIESEL_AND_ELECTRIC",
                "ELECTRIC",
                "LIQUID_PROPANE_GAS",
                "PETROL",
                "PETROL_AND_ELECTRIC",
            ]).optional(),
        }),
        bordero_number: z.string().min(1).max(17),
        access_code: z.string().optional(),
        loading: z.object({
            loaded_at: z.string(),
            duns: z.string(),
            supplier_code: z.string(),
        }),
        unloading: z.object({
            unloaded_at: z.string(),
            duns: z.string(),
            supplier_code: z.string(),
        }),
    }),
    shipments: z.array(z.discriminatedUnion("type", [
        shipmentEmptiesSchema,
        shipmentMaterialsSchema,
    ]))
})

export type TransportationReportRequestRest = z.infer<typeof transportationReportRequestRestSchema>
